import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { switchMap, takeUntil } from 'rxjs/operators';
import { isEmptyEncounterId, currentEncounterId } from '@mona/pdms/data-access-combined';
import { isSameEncounterFilter } from '@mona/shared/utils';
import { makeDefaultAsyncActionEffect } from '@mona/store';
import { DiagnosesState } from '../../entities';
import { DiagnosesApi } from '../../infrastructure';
import { DiagnosesAction } from '../actions';

/**
 * Diagnoses effects
 */
@Injectable()
export class DiagnosesEffects {
    /* Effect Declarations */

    /**
     * Load diagnoses effect
     */

    loadDiagnoses$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DiagnosesAction.loadDiagnosesAction.action),
            switchMap(action =>
                makeDefaultAsyncActionEffect(
                    this.diagnosesApi
                        .getDiagnoses(action.encounterId)
                        .pipe(
                            isSameEncounterFilter(currentEncounterId(this.store), action.encounterId),
                            takeUntil(isEmptyEncounterId(this.store)),
                        ),
                    DiagnosesAction.loadDiagnosesAction,
                ),
            ),
        ),
    );

    /**
     * Constructor
     *
     * @param actions$ Actions
     * @param diagnosesApi DiagnosesApi
     * @param store
     */
    constructor(private actions$: Actions, private diagnosesApi: DiagnosesApi, private store: Store<DiagnosesState>) {}
}
